import { useState } from "react"
import { useLoaderData, useLocation, useNavigate, useOutletContext } from "react-router-dom"

import axios from "axios"
import { useAuth } from "contexts/auth-context"
import { useLayoutEffect } from "react"
import Form from "./form"
import nProgress from "nprogress"
import toast from "react-hot-toast"
import { useSWRConfig } from "swr"
import { usePage } from "contexts/page-context"
import moment from "moment"
import { useAuditLogContext } from "contexts/audit-log-context"

export default function Edit() {
    const { user } = useAuth()
    const { cache } = useSWRConfig()

    const { queueAuditLog } = useAuditLogContext()

    const { setTransition } = usePage()

    const { setTitle } = useOutletContext()

    const loaderData = useLoaderData()

    const location = useLocation()
    const navigate = useNavigate()

    const [prevRouteState, setPrevRouteState] = useState({})

    const [errors, setErrors] = useState({})

    useLayoutEffect(() => {
        const getPrevRouteState = async () => {
            setPrevRouteState({
                back: location.state?.back,
                from: location.state?.from,
                transition: location.state?.transition
            })
        }

        setTransition(location.state?.transition)
        setTitle(`Edit ${loaderData?.name}`)

        getPrevRouteState()
    }, [])

    const handleSubmit = (data) => {
        nProgress.start()

        toast.loading("Loading", {
            id: "submit"
        })

        const url = `${process.env.REACT_APP_INVENTORY_API_URL}/variants/${data?.id}`
        const oldData = {
            name: loaderData.name,
            slug: loaderData.slug
        }
        const payload = {
            name: data.name,
            ...(data.slug ? { slug: data.slug } : {})
        }

        axios.put(url, payload).then((response) => {
            queueAuditLog(url, response.config.method.toUpperCase(), "Edit Variant Data", user?.name, { old: oldData, new: payload }, null, moment().format('YYYY-MM-DD HH:mm:ss'), response.status)

            cache.clear()

            navigate({ pathname: '/variant' })

            toast.success(`Variant ${response.data?.data?.name ?? ''} berhasil diubah`, {
                id: "submit"
            })
        }).catch((error) => {
            if (error.response?.status === 422) {
                setErrors(error.response.data.errors ?? {})
            }

            toast.error(error.response?.data?.message ?? "Gagal mengubah variant", {
                ariaProps: {
                    superscript: error.response?.status
                },
                id: "submit"
            })
        }).finally(() => {
            nProgress.done()
        })
    }

    return (
        <Form data={loaderData} errors={errors} onSubmit={handleSubmit} />
    )
}
